module.exports = __webpack_public_path__ + "img/gray-calander.29815937.svg";